module.exports = __webpack_public_path__ + "img/backgr-home-third-section_1024.b2233e09.png";